





































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import ModalOptions from '@/shared/modal/modal-options.entity';

@Component({
  components: {
    ModalComponent, ModalWarning, VbTooltipSlot,
  },
})
export default class InstancesTransferModal extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({ required: true })
  currentBusinessUnit!: BusinessUnit;

  @Prop({ required: true })
  businessUnitList!: BusinessUnit[];

  @Emit('cancel')
  private cancel(): void {}

  warningMessage: string = 'Deseja realmente prosseguir? Ao clicar no botão Sim, as instâncias serão imediatamentes vinculadas na unidade selecionada.';

  warningModal: boolean = false;

  valid: boolean = false;

  ref: any = this.$refs.ref;

  selectedBusinessUnit = new BusinessUnit({});

  businessUnits: BusinessUnit[] = [];

  closeWarningModal() {
    this.warningModal = false;
  }

  get options(): ModalOptions {
    return {
      title: 'Selecione a unidade de negócio que deseja transferir',
      titleAlign: 'center',
      showClose: false,
      showOk: true,
      labelOk: 'Confirmar',
      okColor: 'bluePrimary',
      showCancel: true,
      labelCancel: 'Cancelar',
      width: 600,
      persistent: true,
      disabledOk: !this.valid,
    }
  }

  setSelected() {
    this.valid = this.selectedBusinessUnit.id !== this.currentBusinessUnit.id;
    this.warningModal = this.valid;
  }

  handleConfirm() {
    this.warningModal = false;
    this.$emit('selectedBusinessUnitTransfer', this.selectedBusinessUnit.id);
    this.cancel();
  }
}

